import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from 'react-intl';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

import FieldSelect from '../../fields/fieldSelect/FieldSelect';
import OptionFilters from '../../optionFilters/OptionFilters';
import DateHint from '../../dates/DateHint';
import ClientRender from '../../clientRender/ClientRender';

export default class ProductPurchaseOccurrence extends React.PureComponent {
  constructor(props) {
    super(props);

    const filters = props.eventParams.optionValues && props.eventParams.optionValues.reduce((acc, optionValue) => {
      acc[optionValue.optionId] = optionValue.id;

      return acc;
    }, {});

    this.state = {
      filters: filters || {},
      timezone: dayjs.tz.guess()
    };
  }

  componentDidMount() {
    this.setState({
      timezone: dayjs.tz.guess()
    });
  }

  componentDidUpdate(_, prevState) {
    const {timezone} = this.state;

    if (prevState.timezone !== timezone) {
      this.setState({
        timezone: dayjs.tz.guess()
      });
    }
  }

  onFilterChange = filters => {
    const {eventParams, selectedVariant, occurrences, onChange, preferFirstOccurrence} = this.props;

    const variantOccurrences = occurrences.filter(occurrence => occurrence.productVariant.code === selectedVariant.code);
    const filteredOccurrences = variantOccurrences.filter(
      ({optionValues}) => Object.entries(filters)
        .filter(([filter, value]) => !!value)
        .every(([filter, value]) => optionValues.some(({optionId, id}) => optionId == filter && id == value))
    );

    const selectionMatchingOccurrence = filteredOccurrences.find(occurrence => occurrence.occurrence === eventParams.occurrence);

    if (selectionMatchingOccurrence && preferFirstOccurrence === undefined) {
      if (selectionMatchingOccurrence.id !== eventParams.id) {
        onChange(selectionMatchingOccurrence);
      }
    } else if (preferFirstOccurrence || filteredOccurrences.length) {
      onChange(filteredOccurrences[0]);
    } else {
      onChange({});
    }

    this.setState({filters});
  };

  render() {
    const {optionGroupId, smallSelect, eventParams, selectedVariant, occurrences, onChange} = this.props;
    const {filters, timezone} = this.state;

    const variantOccurrences = occurrences.filter(occurrence => occurrence.productVariant.code === selectedVariant.code);
    if (!variantOccurrences.length) {
      return false;
    }

    const filteredOccurrences = variantOccurrences.filter(
      ({optionValues}) => Object.entries(filters)
        .filter(([filter, value]) => !!value)
        .every(([filter, value]) => optionValues.some(({optionId, id}) => optionId == filter && id == value))
    );

    const slicedOccurrences = filteredOccurrences.filter(
      (occurrence, idx) => idx < 10 || occurrence.occurrence === eventParams.occurrence
    );

    return (
      <div className="product__options">
        <OptionFilters
          notEmpty
          compact
          optionGroupId={optionGroupId}
          filters={variantOccurrences[0].preset.options}
          values={filters}
          onChange={this.onFilterChange}
        />

        <FieldSelect
          small={smallSelect}
          input={{
            value: eventParams.occurrence || '',
            onChange: evt => onChange(variantOccurrences.find(occurrence => occurrence.occurrence === evt.target.value) || {})
          }}
        >
          {!slicedOccurrences.length ? (
            <FormattedMessage
              id="section.product.occurrence.first"
              children={(message) => (
                <option disabled hidden value="">
                  {message}
                </option>
              )}
            />
          ) : (
            <FormattedMessage
              id="section.product.occurrence.date"
              children={(message) => (
                <option disabled hidden value="">
                  {message}
                </option>
              )}
            />
          )}

          <ClientRender>
            {slicedOccurrences.map((occurrence) => (
              <option key={occurrence.occurrence} value={occurrence.occurrence}>
                {DateHint.getDateHint(dayjs(occurrence.occurrence)) &&
                  DateHint.getDateHint(dayjs(occurrence.occurrence)).toUpperCase() + ', '}
                {dayjs(occurrence.occurrence).tz(timezone).format('DD MMM, HH:mm').toUpperCase()}
                {` (${timezone.replace('/', ', ')})`}
              </option>
            ))}
          </ClientRender>
        </FieldSelect>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productPurchase/productPurchaseOccurrence/ProductPurchaseOccurrence.js